/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 配信者情報作成APIのリクエストボディ
 * @export
 * @interface PostDistributorRequestBody
 */
export interface PostDistributorRequestBody {
    /**
     * 配信者 (会社) 名
     * @type {string}
     * @memberof PostDistributorRequestBody
     */
    name: string;
    /**
     * 配信者 (会社) 説明
     * @type {string}
     * @memberof PostDistributorRequestBody
     */
    description: string;
    /**
     * サーバーに保存されたファイルの名前 (配信者ロゴ画像をアップロードするAPIのレスポンスデータから取得)
     * @type {string}
     * @memberof PostDistributorRequestBody
     */
    imageFileName?: string;
    /**
     * s3に保存されたファイルの名前 (配信者ロゴ画像をアップロードするAPIのレスポンスデータから取得)
     * @type {string}
     * @memberof PostDistributorRequestBody
     */
    imageFileNameS3?: string;
}

export function PostDistributorRequestBodyFromJSON(json: any): PostDistributorRequestBody {
    return PostDistributorRequestBodyFromJSONTyped(json, false);
}

export function PostDistributorRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostDistributorRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
        'imageFileName': !exists(json, 'image_file_name') ? undefined : json['image_file_name'],
        'imageFileNameS3': !exists(json, 'image_file_name_s3') ? undefined : json['image_file_name_s3'],
    };
}

export function PostDistributorRequestBodyToJSON(value?: PostDistributorRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'image_file_name': value.imageFileName,
        'image_file_name_s3': value.imageFileNameS3,
    };
}

